import React from 'react';
export function EditorColorTextIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.307 3h3.386l6 16h-2.136l-1.875-5H8.318l-1.875 5H4.307l6-16zm-1.239 9h5.864l-2.625-7h-.614l-2.625 7z"
  }), React.createElement("path", {
    d: "M2 20h20v3H2v-3z"
  }));
}